import type { StyleProp, TextStyle } from 'react-native';
import { TypographyTextBase } from './MBTypographyBase';
import type { TextProps } from './MBTypographyTypes';

export function withTypographyStyle(style: StyleProp<TextStyle>) {
  // eslint-disable-next-line react/display-name
  return (props: TextProps) => <TypographyTextBase {...props} style={[style, props.style]} />;
}
